import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import ja from "vee-validate/dist/locale/ja";

/**
 * バリデーション用プラグイン読込み
 * ・ロケールを日本語に設定
 * ・インジェクションを手動に設定し、必要なコンポーネントだけnewして使用する
 * ・バリデーションタイミングを手動(空文字)に設定する
 *   全体的な設定であり、必要に応じて個別で指定可能(data-vv-validate-on="change")
 *   設定可能なプロパティはchange(値の変更時)とblur(フォーカスアウト時)とcustom(どうカスタマイズ出来るのか要調査)がある
 */
Validator.localize("ja", ja);
// https://bootstrap-vue.org/docs/reference/validationを参考に「fieldsBagName: "veeFields"」を指定する
Vue.use(VeeValidate, { locale: "ja", inject: false, events: "", fieldsBagName: "veeFields" });
